export const EVENT_PREFIX = 'KreditDE_';

export const ORGANIZATIONS = {
    'kredit.de': 'kredit.de',
    system: 'system', // For testing purposes
} as const;

export type ORGANIZATION = keyof typeof ORGANIZATIONS;

export const TOMBSTONE_REASONS = {
    'automatic-stage-cleaning': 'automatic-stage-cleaning',
    GDPR: 'GDPR',
    'manual-deletion': 'manual-deletion',
} as const;

export const LEAD_DISTRIBUTION_TYPES = {
    all: 'all',
    count: 'count',
    percent: 'percent',
} as const;

export const USER_GENDER = {
    d: 'd',
    m: 'm',
    w: 'w',
} as const;

export const SORT_ORDER = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const;

export type SORT_ORDER = keyof typeof SORT_ORDER;
